var getMenus = function getMenus(type) {
  return [{
    name: '照片编辑器',
    url: 'https://www.gaoding.com/image',
    width: '105px',
    childs: [{
      name: '在线图片编辑',
      url: 'https://www.gaoding.com/image'
    }, {
      name: '批量尺寸调整',
      url: 'https://www.gaoding.com/image'
    }, {
      name: '批量加水印',
      url: 'https://www.gaoding.com/image'
    }]
  }, {
    name: '拼图',
    url: 'https://www.gaoding.com/pintu'
  }, {
    name: '电商海报',
    width: '92px',
    url: 'https://www.gaoding.com/templates/fcc1612576-fc1612571-f1612532',
    childs: [{
      name: '主图设计',
      url: 'https://www.gaoding.com/templates/fcc1612573-fc1612571-f1612532'
    }, {
      name: '详情页设计',
      url: 'https://www.gaoding.com/templates/fcc1612574-fc1612571-f1612532'
    }]
  }, {
    name: '手机海报',
    width: '92px',
    url: 'https://www.gaoding.com/templates/fcc1612534-fc1612533-f1612532',
    childs: [{
      name: '长图海报',
      url: 'https://www.gaoding.com/templates/fcc1612535-fc1612533-f1612532'
    }, {
      name: '电子贺卡',
      url: 'https://www.gaoding.com/templates/fcc1612542-fc1612533-f1612532'
    }]
  }, {
    name: '公众号首图',
    url: 'https://www.gaoding.com/templates/fcc1612548-fc1612547-f1612532',
    width: '105px',
    childs: [{
      name: '公众号次图',
      url: 'https://www.gaoding.com/templates/fcc1612549-fc1612547-f1612532'
    }, {
      name: '广告banner',
      url: 'https://www.gaoding.com/templates/fcc1612553-fc1612547-f1612532'
    }]
  }, {
    name: 'GIF动图',
    url: 'https://www.gaoding.com/templates/fc1615284-f1612532',
    width: '108px',
    childs: [{
      name: '动态表情包',
      url: 'https://www.gaoding.com/templates/fcc1615286-fc1615284-f1612532'
    }, {
      name: '动态二维码',
      url: 'https://www.gaoding.com/templates/fcc1615287-fc1615284-f1612532'
    }].filter(Boolean)
  }, type === 'uupoop' && {
    name: '简易版',
    url: 'https://www.uupoop.com/ex/',
    aTarget: '_self',
    width: '79px',
    childs: [{
      name: '简易版PS',
      url: 'https://www.uupoop.com/ex/',
      aTarget: '_self'
    }, {
      name: '照片特效',
      url: 'https://www.uupoop.com/texiao/',
      aTarget: '_self'
    }, {
      name: '流光字',
      url: 'https://www.uupoop.com/liuguangzi/',
      aTarget: '_self'
    }]
  }, {
    name: '智能抠图',
    url: 'https://koutu.gaoding.com/',
    bgColor: '#2254F4',
    color: 'white'
  }, {
    name: '证件照换底色',
    url: 'https://koutu.gaoding.com/passport',
    bgColor: '#2254F4',
    color: 'white'
  }].filter(Boolean);
};

export var PS_MENUS = getMenus('ps');
export var UUPOOP_MENUS = getMenus('uupoop');